import { Modal } from 'antd';
import React from 'react';

interface IConfirmationDialogProps {
  children: React.ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
  isOpen: boolean;
  title: string;
  loading: boolean;
  width?: string | number;
}

const DEFAULT_CONFIRMATION_MODAL_WIDTH = 420;

const ConfirmationDialog: React.FC<IConfirmationDialogProps> = ({
  children,
  onConfirm,
  onCancel,
  isOpen,
  title,
  loading,
  width,
}) => {
  return (
    <>
      <Modal
        title={title}
        width={width ? width : DEFAULT_CONFIRMATION_MODAL_WIDTH}
        centered
        open={isOpen}
        onOk={onConfirm}
        onCancel={!loading && onCancel}
        destroyOnClose={true}
        closable={false}
        cancelButtonProps={{ disabled: loading }}
        maskClosable={!loading}
        okButtonProps={{ disabled: loading }}
      >
        {children}
      </Modal>
    </>
  );
};

export default ConfirmationDialog;
